<template>
    <el-dialog
    title="选择课程"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="80rem">
        <div class="soft-box">
            <Table :totalSize="tableData.length" :pagination="false" :operationWidth="350" :currentPage="pages.current"
                :pageSize="pages.size" navHeight=40 ref="table"
                        :tableData="tableData" :tableKey="tableKey">
                <template slot="operation" slot-scope="data">
                    <div class="btn-button" @click="startTask(data.data.row)">开始学习</div>      
                </template>
            </Table>
        </div>
    </el-dialog>
</template>

<script>
import {QueryCourseDetail} from '@/api/course';
import { StudyCourse } from '@/api/study';
    export default {
        data(){
            return {
                dialogVisible:false,
                tableData:[],
                pages:{
                    current:1,
                    size:10
                },
                tableKey:[
                    {
                        name:'课程名称',
                        value:'courseName'
                    },
                    {
                        name:'',
                        value:'operation',
                        slot:'operation'
                    },
                ]
            }
        },
        methods:{
            startTask(item){
                StudyCourse().then(res=>{
                    if(res.data&&res.code==200){
                        this.dialogVisible=false;
                        this.$router.push({
                        path:'/course/studyCourse',
                        query: { id: item.id,openCourseId:item.openCourseId,courseLearningSource:'course_task'}
                    });      
                    }
                })
                // QueryCourseDetail({id:item.id}).then(res=>{
                //     if(res.code==200){
                //         this.dialogVisible=false;
                //         localStorage.setItem('course_study_back',this.$route.fullPath);
                //         localStorage.setItem('base_detail',JSON.stringify(res.data));
                //         this.$router.push({
                //         path:'/course/studyCourse',
                //         query: { id: item.id,openCourseId:item.openCourseId,courseLearningSource:'course_task'}
                //     });      
                //     }
                // })
            }
        }
    }
</script>

<style lang="less" scoped>
.soft-box{
    height: 50rem;
    overflow: auto;
}
.btn-button {
    width: 72px;
    height: 26px;
    background: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    cursor: pointer;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
/deep/.el-dialog__header{
    font-weight: 700;
    padding: 3rem 5rem;
}
/deep/.el-dialog__body {
    padding: 0 3rem 5rem 3rem;
}
</style>